module.exports = __webpack_public_path__ + "img/banner.38252c75.jpg";